import type { ReactElement } from 'react'
import { createContext, useContext, useMemo } from 'react'

type Type = {
  host: string
}

const ApiGatewayContext = createContext<Type>({
  host: '',
})

type Props = {
  children: ReactElement
  host: string
}

export const ApiGatewayProvider = ({ children, host }: Props) => {
  const value = useMemo(() => ({ host }), [host])

  return <ApiGatewayContext.Provider value={value}>{children}</ApiGatewayContext.Provider>
}

export const useApiGatewayHost = () => {
  const { host } = useContext(ApiGatewayContext)

  return host
}
